/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WohnortInputs */

const en__field_wohnort = /** @type {(inputs: _Field_WohnortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Living Place`)
};

const de__field_wohnort = /** @type {(inputs: _Field_WohnortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wohnort`)
};

/**
* | output |
* | --- |
* | "Living Place" |
*
* @param {_Field_WohnortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_wohnort = /** @type {((inputs?: _Field_WohnortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WohnortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_wohnort(inputs)
	return de__field_wohnort(inputs)
});